var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _rect2, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _rect3, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsCatalog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 196,
    viewBox: "0 0 217 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3721,
    y: 60.1582,
    width: 132.632,
    height: 134.842,
    rx: 5.89473,
    fill: "#D8F1E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.474 27.5791V175.301C197.474 179.244 194.277 182.441 190.334 182.441H9.14062C5.19697 182.441 2 179.244 2 175.301V98.539C2 94.5953 5.19696 91.3983 9.14061 91.3983H40.8271",
    stroke: "#003311",
    strokeWidth: 2.67773,
    strokeDasharray: "2.68 4.46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.894 182.441H9.14061C5.19696 182.441 2 179.244 2 175.301V98.539C2 94.5953 5.19696 91.3984 9.14061 91.3984H40.8271",
    stroke: "#003311",
    strokeWidth: 2.67773
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.481 177.086H107.771V187.797H118.481V177.086Z",
    fill: "#22EE88",
    stroke: "#003311",
    strokeWidth: 2.67773,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4867_792)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.1143,
    y: 13.7442,
    width: 155.217,
    height: 155.217,
    rx: 7.35961,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2217,
    y: 12.8516,
    width: 157.002,
    height: 157.002,
    rx: 8.25218,
    stroke: "#DDDCDB",
    strokeWidth: 1.78515
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4951 114.502H64.4249L70.3954 120.203C73.7423 123.399 77.6664 125.927 81.9601 127.652L92.1878 131.763C94.7088 132.776 96.3605 135.219 96.3605 137.937V139.798H49.4974V114.499L49.4951 114.502Z",
    fill: "#72D0A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8548 135.393L49.498 135.393V136.253L96.1473 136.253L96.017 135.817L95.8548 135.393Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1724 128.74C54.5944 128.74 52.5 126.643 52.5 124.068V114.502H61.8471V124.068C61.8471 126.646 59.7504 128.74 57.1747 128.74H57.1724ZM53.3601 115.36V124.065C53.3601 126.169 55.0712 127.878 57.1724 127.878C59.2736 127.878 60.9847 126.167 60.9847 124.065V115.36H53.3578H53.3601Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.3594,
    y: 114.502,
    width: 7.62418,
    height: 1.23391,
    fill: "#72D0A1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4867_792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.781 53.9101C159.781 53.9238 159.781 53.9376 159.781 53.9513C158.719 54.5562 156.359 55.5725 151.762 56.2189C147.475 56.8219 142.353 56.9178 136.937 56.4981C136.884 55.3725 136.904 54.2822 136.998 53.2312C137.09 53.2371 137.183 53.2404 137.277 53.2404C138.262 53.2404 139.329 52.916 140.583 52.2427C141.902 51.5337 143.264 50.5266 144.706 49.4605C146.455 48.1679 148.263 46.8315 150.192 45.8741C152.313 44.8221 154.252 44.4107 156.116 44.6175C157.213 45.7906 158.085 47.1317 158.711 48.6101C159.421 50.2886 159.781 52.0715 159.781 53.9097V53.9101Z",
    fill: "#72D0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.465 41.3644C152.923 41.9814 154.247 42.8383 155.409 43.9146C151.253 43.8082 147.582 46.5213 144.317 48.9346C142.895 49.9863 141.551 50.9797 140.273 51.6667C139.024 52.3377 137.994 52.632 137.065 52.5803C137.221 51.2818 137.491 50.0468 137.876 48.8845C138.498 47.0018 139.42 45.3027 140.615 43.8347C142.496 41.5245 144.479 40.5128 144.792 40.3622C145.246 40.317 145.704 40.2944 146.165 40.2944C148.003 40.2944 149.787 40.6545 151.465 41.3644Z",
    fill: "#72D0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.538 44.2826C137.788 43.0319 139.244 42.0503 140.866 41.3645C141.576 41.0641 142.306 40.8264 143.05 40.652C142.228 41.2339 141.172 42.122 140.132 43.3933C138.88 44.9235 137.914 46.6939 137.263 48.6552C136.862 49.8623 136.58 51.1435 136.418 52.4894C135.508 52.2943 134.847 51.8655 134.45 51.2119C133.537 49.7092 134.236 47.4481 134.32 47.1924C134.922 46.1313 135.664 45.1565 136.538 44.2826H136.538Z",
    fill: "#72D0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.329 49.3581C133.339 50.0848 133.477 50.869 133.889 51.5485C134.394 52.3819 135.221 52.9174 136.349 53.1429C136.253 54.2044 136.23 55.3042 136.28 56.438C135.026 56.2986 133.808 56.0053 132.649 55.5634C132.583 55.0181 132.55 54.4662 132.55 53.9095C132.55 52.342 132.812 50.8144 133.329 49.3575L133.329 49.3581Z",
    fill: "#72D0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.758 56.3019C133.899 56.7058 135.093 56.9733 136.317 57.1006C136.39 58.1359 136.532 59.1195 136.743 60.0435C135.8 60.1031 135.03 60.3724 134.446 60.8471C134.135 60.3224 133.859 59.7764 133.619 59.2098C133.222 58.2704 132.934 57.2983 132.758 56.3019Z",
    fill: "#72D0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.798 61.4076C135.304 60.9687 136.011 60.7278 136.904 60.6905C137.039 61.1874 137.194 61.6656 137.37 62.1235C137.92 63.5565 138.674 64.8042 139.622 65.8533C138.493 65.2346 137.46 64.4595 136.538 63.5378C135.883 62.8825 135.302 62.1703 134.798 61.4076H134.798Z",
    fill: "#72D0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.464 66.4561C149.786 67.166 148.003 67.5261 146.165 67.5261C144.569 67.5261 143.014 67.2544 141.533 66.7179C139.948 65.5268 138.752 63.9027 137.979 61.8894C137.833 61.509 137.702 61.1136 137.586 60.7045C139.156 60.8393 140.551 61.6881 142.146 62.6592C143.626 63.5603 145.303 64.5815 147.387 65.1393C148.462 65.4273 149.57 65.5713 150.724 65.5713C151.669 65.5713 152.644 65.4741 153.658 65.281C152.967 65.7373 152.235 66.1307 151.464 66.4564V66.4561Z",
    fill: "#72D0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 59.2097C158.025 60.8309 157.043 62.2871 155.793 63.5378C155.523 63.8079 155.242 64.0648 154.953 64.3096C148.839 65.9668 145.465 63.9133 142.487 62.0999C140.818 61.0836 139.237 60.1219 137.413 60.0375C137.199 59.1364 137.053 58.1744 136.977 57.1578C139.172 57.3257 141.319 57.4095 143.383 57.4095C146.424 57.4095 149.286 57.2278 151.852 56.8668C155.185 56.3981 157.958 55.6384 159.757 54.7081C159.668 56.2645 159.317 57.7754 158.711 59.2097Z",
    fill: "#72D0A1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8369 21.9135C33.8369 18.9056 36.2753 16.4673 39.2831 16.4673H108.722V91.3528H33.8369V21.9135Z",
    fill: "#C8FBE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8199 75.695V48.8351L50.1758 52.3251V39.249L66.1824 32.5128H76.7897L92.916 39.249V52.3251L85.2741 48.8351V75.695H57.8199Z",
    fill: "#72D0A1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6743 51.5979L72.8076 49.706V42.4233H80.5388V49.706L76.6721 51.5979H76.6743ZM73.6284 49.1943L76.6743 50.6835L79.7202 49.1943V43.2441H73.6306V49.1943H73.6284Z",
    fill: "#C8FBE1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.547 35.6957C67.4256 35.6957 65.5408 32.925 65.4668 32.814L66.1795 32.5108C66.2448 32.6066 67.885 34.8749 71.5492 34.8749V35.6957H71.547Z",
    fill: "#C8FBE1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5469 35.6958V34.875C75.2089 34.875 76.7325 32.612 76.7978 32.5162L77.5584 32.8407C77.4843 32.9517 75.6683 35.6958 71.5469 35.6958Z",
    fill: "#C8FBE1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.723 91.3528H183.608V160.792C183.608 163.8 181.17 166.238 178.162 166.238H108.723V91.3528Z",
    fill: "#C8FBE1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.01 127.636L158.234 117.31V102.245H153.789V110.477C153.789 114.249 150.699 117.31 146.891 117.31H146.845C143.037 117.31 139.947 114.249 139.947 110.477V102.245H135.502V117.31H135.457L137.68 127.636L123.7 154.665H169.993L156.013 127.636H156.01Z",
    fill: "#72D0A1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.378 127.434H137.316V128.115H156.378V127.434Z",
    fill: "#C8FBE1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 0.0000610352,
    width: 50,
    height: 50,
    rx: 8,
    fill: "#22EE88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.477 9.34146C183.55 9.34146 176.289 16.6027 176.289 25.529C176.289 34.4552 183.55 41.7165 192.477 41.7165C201.403 41.7165 208.664 34.4552 208.664 25.529C208.664 16.6027 201.397 9.34146 192.477 9.34146ZM192.477 40.5602C184.186 40.5602 177.445 33.8193 177.445 25.529C177.445 17.2386 184.186 10.4977 192.477 10.4977C200.767 10.4977 207.508 17.2386 207.508 25.529C207.508 33.8193 200.767 40.5602 192.477 40.5602Z",
    fill: "#003311"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.113 19.3372L192.477 22.9737L188.841 19.3372H188.025L186.291 21.0716V21.8868L189.927 25.5232L186.291 29.1596V29.9748L188.025 31.7091H188.841L192.477 28.0727L196.113 31.7091H196.929L198.663 29.9748V29.1596L195.026 25.5232L198.663 21.8868V21.0716L196.929 19.3372H196.113ZM193.801 25.1185V25.9337L197.437 29.5701L196.518 30.4893L192.882 26.8529H192.066L188.43 30.4893L187.511 29.5701L191.147 25.9337V25.1185L187.511 21.4821L188.43 20.5629L192.066 24.1993H192.882L196.518 20.5629L197.437 21.4821L193.801 25.1185Z",
    fill: "#003311"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.567 21.8086L189.277 20.6797C188.824 20.2835 188.156 20.2583 187.674 20.6193C187.055 21.0841 186.99 21.9902 187.538 22.5381L188.642 23.6422C189.668 24.6683 189.668 26.3319 188.642 27.3579L187.538 28.462C186.99 29.0099 187.055 29.916 187.674 30.3808C188.156 30.7418 188.824 30.7166 189.277 30.3205L190.567 29.1915C191.674 28.2231 193.326 28.2231 194.433 29.1915L195.702 30.3016C196.151 30.6946 196.828 30.6721 197.25 30.2501C197.672 29.828 197.695 29.151 197.302 28.7018L196.191 27.4332C195.223 26.3264 195.223 24.6738 196.191 23.567L197.302 22.2983C197.695 21.8491 197.672 21.1721 197.25 20.7501C196.828 20.328 196.151 20.3055 195.702 20.6985L194.433 21.8086C193.326 22.777 191.674 22.777 190.567 21.8086Z",
    fill: "#003311"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4867_792",
    x: 12.1567,
    y: 11.959,
    width: 183.32,
    height: 183.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.0665,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4867_792"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.13301
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.0665
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4867_792"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.0665,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_4867_792"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.9064,
    dy: 12.266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.66626
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4867_792",
    result: "effect2_dropShadow_4867_792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4867_792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4867_792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2311,
    height: 27.2311,
    fill: "white",
    transform: "translate(132.55 40.2944)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsCatalog);
export default __webpack_public_path__ + "static/media/products-catalog.cb08a9b695dac04436b3b38b345a3b26.svg";
export { ForwardRef as ReactComponent };